class ArnPCardMediaSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.insideDulicateSlide = !!this.closest(".swiper-slide-duplicate");
        this.elms = {
            sliderContainer: this.querySelector(".arn-swiper"),
        };

        this.initSlider();
    }

    disconnectedCallback() {
        this.arnSlider.destroy();
    }

    initSlider() {
        const { sliderContainer } = this.elms;
        //console.log('initSlider::');
        //this.querySelectorAll(".arn-swiper-slide").forEach((slider) => (slider.hidden = false));

        this.arnSlider = new MinimogLibs.Swiper(sliderContainer, {
            slidesPerView: 1,
            showPagination: false,
            showNavigation: false,
            loop: false,
            pagination: false,
            threshold: 5,
            speed: 800,
            autoplay: {
                delay: 1000,
                stopOnLastSlide: true,
            },
            nested: true,
            touchStartPreventDefault: false,
            on: {
                init: (info) => {
                    requestAnimationFrame(() => {
                        info.update();
                        //info.updateSlides();
                    });

                    const onMouseEnter = (evt) => {
                        console.log('mouseenter::', info);
                        if (info.autoplay.running) {
                            info.autoplay.run();
                        } else {
                            info.autoplay.start();
                        }
                    }

                    const onMouseLeave = (evt) => {
                        info.autoplay.stop();
                        info.slideTo(0, 150);
                    }
                    this.addEventListener("mouseenter", onMouseEnter);
                    this.addEventListener("mouseleave", onMouseLeave);
                },
                breakpoint: (e, i) => {},
            },
        });
        this.arnSlider.autoplay.stop();
    }
}
customElements.define("arn-pcard-media-slider", ArnPCardMediaSlider);

document.querySelectorAll('.m-breadcrumb--item-current.m-breadcrumb--item').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/<br\s*\/?>/, ' ');
});



